import sendInteractionToGtm from '~/shared/gtm/sendInteractionToGtm';

type Args = {
  category: string;
  info?: string;
};

const sendLanguageToGtm = ({ category, info }: Args) => {
  sendInteractionToGtm({
    eventCategory: category,
    eventAction: 'footer',
    eventInfo: info,
  });
};

export default sendLanguageToGtm;
